exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ag-pre-table .ag-header-cell-label{justify-content:center!important}.mailjet-status-cell .tag{max-width:100%;min-width:0}.mailjet-status-cell .tag .ellipsis-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;display:block}.status-tooltip{max-width:260px;background-color:#2b2b2b;color:#fff;border:1px solid #6b2fae;border-radius:8px;padding:.4rem .7rem;box-shadow:0 6px 16px rgba(0,0,0,.25);font-size:.8rem;line-height:1.35}.status-tooltip__label{margin-bottom:4px}.status-tooltip__label strong{color:#fff}.status-tooltip__desc{font-weight:400;opacity:.9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c885d9f0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/climan/Surveys.vue
// module id = 1353
// module chunks = 2